import { render, staticRenderFns } from "./AssetsCardStarter.vue?vue&type=template&id=528890de&"
import script from "./AssetsCardStarter.vue?vue&type=script&lang=js&"
export * from "./AssetsCardStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports